import request from '@/lib/request';

const api = {};

api.queryProductList = reqData => request({
  url: 'v4/show_window/fetch_show_case_product',
  method: 'post',
  data: reqData,
});

api.batchShow = reqData => request({
  url: 'v4/show_window/product_display_batch',
  method: 'post',
  data: reqData,
});

api.batchSetTop = reqData => request({
  url: 'v4/show_window/product_set_top_batch',
  method: 'post',
  data: reqData,
});

api.batchDelete = reqData => request({
  url: 'v4/show_window/delete_media_product_batch',
  method: 'post',
  data: reqData,
});

api.batchUpdate = reqData => request({
  url: 'v4/show_window/update_product_batch',
  method: 'post',
  data: reqData,
});

api.batchSync = reqData => request({
  url: 'v3/show_window/sync_product_to_multi_user',
  method: 'post',
  data: reqData,
});

api.batchEdit = reqData => request({
  url: 'v4/show_window/material_audit_batch',
  method: 'post',
  data: reqData,
});

api.findProductOperateLog = reqData => request({
  url: 'v4/show_window/find_product_operate_log',
  method: 'post',
  data: reqData,
});

api.getMaterialConfig = (reqData, autoErrorTips = false) => request({
  url: 'v1/show_window/material_edit_cfg',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
